module.exports = __webpack_public_path__ + "static/media/sidemenu.cc4773f3.svg";